import { Selector } from '@ngxs/store';
import { AuthenticationSettingsState, AuthenticationSettingsStateModel } from './authentication-settings.state';
import { MicrosoftEntraIdAuthenticationSettings } from './microsoft-entra-id-authentication-settings';
import { AuthenticationMethod } from './authentication-method';
import { MicrosoftEntraIdService } from 'src/app/services/microsoft-entra-id/microsoft-entra-id-service';

export class AuthenticationSettingsSelectors {
   @Selector([AuthenticationSettingsState])
   public static useWindowsAuthentication(state: AuthenticationSettingsStateModel): boolean {
      return state.authenticationMethod === AuthenticationMethod.Domain;
   }

   @Selector([AuthenticationSettingsState])
   public static useMicrosoftEntraIdAuthentication(state: AuthenticationSettingsStateModel): boolean {
      return state.authenticationMethod === AuthenticationMethod.MicrosoftEntraId;
   }

   @Selector([AuthenticationSettingsState])
   public static performAutoMicrosoftEntraIdAuthentication(state: AuthenticationSettingsStateModel): boolean {
      if (state.authenticationMethod !== AuthenticationMethod.MicrosoftEntraId) {
         return false;
      }

      return MicrosoftEntraIdService.isAutoMicrosoftEntraIdLoginEnabled;
   }

   @Selector([AuthenticationSettingsState])
   public static getMicrosoftEntraIdAuthenticationSettings(state: AuthenticationSettingsStateModel): MicrosoftEntraIdAuthenticationSettings | undefined {
      return state.microsoftEntraIdAuthenticationSettings;
   }
}
